import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";

import { CustomDatePicker } from "ui/partials/comment/RelatedMeetingDateFilter";
import ErrorMessage from "ui/components/footer/ErrorMessage";
import { isAfter, isEqual } from "date-fns";
import { useAdvancedViewFiltersStore } from "data/store/global-search/AdvancedViewFiltersStore";
import { GlobalSearchSelectOption } from "data/@types/GlobalSearchData";

export const DateRangePicker = ({
  label,
  activityType,
}: {
  label: string;
  activityType: GlobalSearchSelectOption;
}) => {
  const activeFilters = useAdvancedViewFiltersStore(
    (state) => state.filtersByActivity[activityType] || {},
  );
  const setActiveFilters = useAdvancedViewFiltersStore(
    (state) => state.setFiltersForActivity,
  );

  const [startDate, setStartDate] = useState<Date | null>(
    activeFilters[label]?.valueDateRange?.from,
  );
  const [endDate, setEndDate] = useState<Date | null>(
    activeFilters[label]?.valueDateRange?.to,
  );

  const [isDatePeriodValid, setIsDatePeriodValid] = useState(true);
  const [isInteracting, setIsInteracting] = useState(false);

  const shouldDisplayError = !isInteracting && !isDatePeriodValid;

  useEffect(() => {
    const validateDatePeriod = () => {
      if (endDate && startDate) {
        setIsDatePeriodValid(
          isEqual(endDate, startDate) || isAfter(endDate, startDate),
        );
      } else {
        setIsDatePeriodValid(true);
      }
    };

    validateDatePeriod();

    setActiveFilters(activityType, {
      ...activeFilters,
      [label]: {
        ...activeFilters[label],
        valueDateRange: {
          from: startDate,
          to: endDate,
        },
      },
    });
  }, [startDate, endDate]);

  const handleInteractionStart = () => {
    setIsInteracting(true);
  };

  const handleInteractionEnd = () => {
    setIsInteracting(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "0.8rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1.6rem",
          padding: "0.8rem",
        }}
      >
        <CustomDatePicker
          label="Date Range From"
          value={startDate}
          setValue={(value) => setStartDate(value)}
          handleInteractionStart={handleInteractionStart}
          handleInteractionEnd={handleInteractionEnd}
          shouldDisplayError={shouldDisplayError}
        />

        <CustomDatePicker
          label="Date Range To"
          value={endDate}
          setValue={(value) => setEndDate(value)}
          handleInteractionStart={handleInteractionStart}
          handleInteractionEnd={handleInteractionEnd}
          shouldDisplayError={shouldDisplayError}
        />
      </Box>
      <Box>
        {shouldDisplayError && (
          <ErrorMessage>
            The End date must be the same as or later than the Start date
          </ErrorMessage>
        )}
      </Box>
    </Box>
  );
};
